export default {
  LOCALIZATION: 'localization',
  APP_THEME: 'app_theme',
  COMPANY_ID: 'company_id',
  ROLE_TITLE: 'role_title',
  DISPLAY_OPTIONS: 'display_options',
};
